// extracted by mini-css-extract-plugin
export default {"cls1":"u7SeAuJ4NRXGj0s5Bipp","cls2":"A_V7DsJRTW08DUOBATtY u7SeAuJ4NRXGj0s5Bipp"};